import api from '@/axios'
import Axios from 'axios'
import { resolveResponseData } from '@/services/helpers'
import qs from 'qs'
import {
    CURRENT_SUBNET,
    DEFAULT_NETWORK,
    subnet_url,
} from '@/store/modules/network/network'
import store from '@/store'
import { endpoints } from '../../../endpoint'

const EVM_TRANSACTIONS_API_BASE_URL = endpoints.VUE_APP_EVM_TRANSACTIONS_V2_API_BASE_URL as string

export interface IEVMTransactionParams {
    toAddress?: string // address
    fromAddress?: string // address
    address?: string // address (to or from)
    hash?: string // tx hash
    blockStart?: number // Starting block number inclusive
    blockEnd?: number // Ending block number exclusive
    limit?: number
}

/**
 * Get a list of EVM transactions (ACT-Chain)
 * @param params api release
 * @link https://docs.dcm.network/build/tools/indexer#list-ACT-Chain-transactions
 */
export function getEVMTransaction(params?: IEVMTransactionParams) {
    return api
        .get(EVM_TRANSACTIONS_API_BASE_URL, {
            params,
            paramsSerializer: (params) =>
                qs.stringify(params, { arrayFormat: 'repeat' }),
        })
        .then(resolveResponseData)
}

const requestHeader = {
    'Content-Type': 'application/json',
}

export async function getEVMTransactionByHash(params: { hash: string }) {
    store.commit('Transactions/fetching', true)
    let VALIDATOR_URL: string
    if (CURRENT_SUBNET !== null) {
        VALIDATOR_URL = subnet_url
    } else {
        VALIDATOR_URL = DEFAULT_NETWORK.dcommGoEthUrl
    }
    const newRes = await Axios.post(
        VALIDATOR_URL,
        JSON.stringify({
            jsonrpc: '2.0',
            method: 'eth_getTransactionByHash',
            params: [params.hash],
            id: 1,
        }),
        {
            headers: requestHeader,
        }
    ).then((res) => res.data.result)
    store.commit('Transactions/fetching', false)
    return newRes
}
